// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2CzHP","title":"Info_title__aMKqb","selects":"Info_selects__2eSOF","requiredAsterisk":"Info_requiredAsterisk__1rthi"};